import {Component, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'popup-coletor-custos',
  templateUrl: './popup-coletor-custos.component.html',
  styleUrls: ['./popup-coletor-custos.component.css']
})
export class PopupColetorCustosComponent implements OnInit {
  tipoColetor: string;
  CentroCustos: boolean;
  DiagramaRede: boolean;
  OrdemInterna: boolean;

  constructor(
    private dialogRef: MatDialogRef<PopupColetorCustosComponent>
    ) { this.tipoColetor = JSON.parse(localStorage.getItem('tipoColetor')); }

  ngOnInit() {
    if(this.tipoColetor == "N" )
      this.DiagramaRede = true;
    else if(this.tipoColetor == 'K')
      this.CentroCustos = true;
    else if(this.tipoColetor == 'F')
      this.OrdemInterna = true;
  }

  closePopup(){
    this.dialogRef.close("");
  }

}
